/**
 * Normalize category id from cart/checkout line items (string id or { _id, id } object).
 */
export function resolveCategoryId(item) {
  const raw = item?.categoryId ?? item?.category ?? null;
  if (raw == null) return null;
  if (typeof raw === "string") return raw;
  if (typeof raw === "object") {
    if (raw._id != null) return String(raw._id);
    if (raw.id != null) return String(raw.id);
  }
  return String(raw);
}

export function resolveProductId(product) {
  const pid = product?.productId ?? product?.id;
  if (!pid) return null;
  if (typeof pid === "string") return pid;
  if (typeof pid === "object") {
    if (pid._id != null) return String(pid._id);
    if (pid.id != null) return String(pid.id);
  }
  return String(pid);
}
